<template>
  <div>
    <img
      :alt="altText"
      :class="classes"
      :src="url"
      @click="onClick"
    >
  </div>
</template>

<script>
// @flow
import { ChatchampButton } from '@chatchamp/chatchamp-types'

import { buttonClickMixin, postMessageMixin } from '../../../mixins'

export default {
  mixins: [buttonClickMixin, postMessageMixin],
  props: {
    message: {
      type: Object, // ChatchampMessage<ImageMessage>
      default: () => {
      }
    }
  },
  computed: {
    url (): string {
      return this.message.content.url
    },
    buttons (): Array<ChatchampButton> {
      return this.message.content.quick_replies ?? []
    },
    isDisabled (): boolean {
      const button = this.validButton()
      if (!button) return false
      return !this.message.lastMessage && button.type !== 'url'
    },
    classes (): Object {
      return {
        'image-message': true,
        'image-message-is-button': !!this.validButton(),
        'image-message-is-disabled': this.isDisabled
      }
    },
    altText () {
      return this.message.content.imageAltText || ''
    }
  },
  methods: {
    onClick (): void {
      if (this.isDisabled) return

      const button = this.validButton()
      if (button) {
        this.clickButton(button, this.message)
        if (button.attribute) this.notifyUserAttributeSet(button.attribute)
      } else this.notifyImage(this.url)
    },
    validButton (): ChatchampButton {
      return Array.isArray(this.buttons) && this.buttons.find(button => (button.type === 'url' || button.type === 'postback'))
    }
  }
}
</script>

<style src="./image-message.scss" />
